// ============================================
// ROLC OneROLC - Storage Utils
// Version: 3.6.0
// ============================================

import { CONFIG } from '../config/constants.js';

// ============================================
// Token
// ============================================
export function getToken() {
    return localStorage.getItem(CONFIG.TOKEN_KEY);
}

export function setToken(token) {
    localStorage.setItem(CONFIG.TOKEN_KEY, token);
}

export function removeToken() {
    localStorage.removeItem(CONFIG.TOKEN_KEY);
}

// ============================================
// Session ID
// ============================================
export function getSessionId() {
    return localStorage.getItem(CONFIG.SESSION_ID_KEY);
}

export function setSessionId(sessionId) {
    localStorage.setItem(CONFIG.SESSION_ID_KEY, sessionId);
}

export function removeSessionId() {
    localStorage.removeItem(CONFIG.SESSION_ID_KEY);
}

// ============================================
// Name
// ============================================
export function getName() {
    return localStorage.getItem(CONFIG.NAME_KEY);
}

export function setName(name) {
    localStorage.setItem(CONFIG.NAME_KEY, name);
}

export function removeName() {
    localStorage.removeItem(CONFIG.NAME_KEY);
}

// ============================================
// Role
// ============================================
export function getRole() {
    return localStorage.getItem(CONFIG.ROLE_KEY);
}

export function setRole(role) {
    localStorage.setItem(CONFIG.ROLE_KEY, role);
}

export function removeRole() {
    localStorage.removeItem(CONFIG.ROLE_KEY);
}

// ============================================
// Master Token (sessionStorage)
// ============================================
export function getMasterToken() {
    return sessionStorage.getItem("rolc_master_token");
}

export function setMasterToken(token) {
    sessionStorage.setItem("rolc_master_token", token);
}

export function removeMasterToken() {
    sessionStorage.removeItem("rolc_master_token");
}

// ============================================
// Master Admin Flag
// ============================================
export function getIsMasterAdmin() {
    return localStorage.getItem("rolc_master_admin") === "1";
}

export function setIsMasterAdmin(isAdmin) {
    localStorage.setItem("rolc_master_admin", isAdmin ? "1" : "0");
}

export function removeIsMasterAdmin() {
    localStorage.removeItem("rolc_master_admin");
}

// ============================================
// Last Activity (idle tracking)
// ============================================
export function getLastActivity() {
    return localStorage.getItem("rolc_last_activity");
}

export function setLastActivity() {
    localStorage.setItem("rolc_last_activity", String(Date.now()));
}

// ============================================
// Generic Cache
// ============================================
export function getCached(key) {
    try {
        const raw = localStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
}

export function setCached(key, data) {
    try {
        localStorage.setItem(key, JSON.stringify(data));
    } catch (e) {}
}

export function getCachedWithTimestamp(key, tsKey, maxAge, sessionKey) {
    try {
        // Check session ID — invalidate cache if session changed
        if (sessionKey) {
            const currentSession = localStorage.getItem(sessionKey);
            const cachedSession = localStorage.getItem(CONFIG.CACHED_SESSION_KEY);
            if (currentSession !== cachedSession) {
                localStorage.setItem(CONFIG.CACHED_SESSION_KEY, currentSession || '');
                return null;
            }
        }
        const ts = localStorage.getItem(tsKey);
        if (!ts) return null;
        if (Date.now() - parseInt(ts, 10) > maxAge) return null;
        const raw = localStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
}

export function setCachedWithTimestamp(key, tsKey, data, sessionKey) {
    try {
        localStorage.setItem(key, JSON.stringify(data));
        localStorage.setItem(tsKey, String(Date.now()));
        if (sessionKey) {
            localStorage.setItem(CONFIG.CACHED_SESSION_KEY, localStorage.getItem(sessionKey) || '');
        }
    } catch (e) {}
}

// ============================================
// Clear All Auth
// ============================================
export function clearAuth() {
    removeToken();
    removeSessionId();
    removeName();
    removeRole();
    removeMasterToken();
    removeIsMasterAdmin();
    // Clear cached surveys and session ID marker
    localStorage.removeItem(CONFIG.CACHED_SESSION_KEY);
    localStorage.removeItem(CONFIG.SURVEYS_KEY);
    localStorage.removeItem(CONFIG.SURVEYS_TS_KEY);
}


